export default __webpack_public_path__ + "static/anilPokhriyal4-9793a5f7b040bfb5ec68f17bb955bf9c.jpg";